import React, { useRef, useEffect, useState } from "react";
import ServiceForm from "../../components/ServiceForm/ServiceForm";
import HeadPage from "../../components/HeadPage/HeadPage";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../styles/pages/restaurants.module.scss";
import ScrollDown from "../../components/ScrollDown/ScrollDown";
import { useRouter } from "next/dist/client/router";
import OurRestaurants from "../../components/NewRestaurants/NewRestaurants";
import RestaurantsSections from "../../components/RestaurantsSections/RestaurantsSections";
import MagazineContent from "../../components/MagazineContent/MagazineContent";
import CardCarousel from "../../components/CardCarousel/CardCarousel";

const Restaurants = ({ menuItems, dataContent, properties, magazine, carousel }) => {
  const scrollToRef = useRef(null);
  const [app, setApp] = useState(false);
  const [serviceName, setServiceName] = useState('');
  const [serviceNameEn, setServiceNameEn] = useState('');
  const [serviceType, setServiceType] = useState('');
  const router = useRouter();

  const getId = (str) => {
    return str.split(" ").slice(0, 1).pop().toLowerCase();
  };
  useEffect(() => {
    if (router.asPath.includes("?app=true")) {
      setApp(true);
    }
  }, []);

  const restaurants = dataContent.restaurants;
  const bigpartner = dataContent.bigpartner;
  const alternates = dataContent.alternates;
  const map = dataContent.map;

  return (
    <TheMallOutletLayout menuItems={menuItems} app={app}>
      {!app && (
        <div id="head" ref={scrollToRef}>
          <HeadPage {...dataContent?.head} />
        </div>
      )}

      <div className={"centeredSection " + styles.ourRestaurants} id="restaurants" style={{marginTop: '3rem'}}>
        <OurRestaurants
          title={restaurants.title}
          card={restaurants.card}
          booking={restaurants.booking}
          imageRight={restaurants.image_right}
          imageLeft={restaurants.image_left}
        />
      </div>

      {alternates && alternates.length && alternates.map( (s, ind) => 
        <div className={"centeredSection " + styles.ourRestaurants} key={"alternates-"+ind} id={"alternates-"+ind} style={{marginTop: '0'}}>
          <RestaurantsSections 
            ind={ind}
            title={s.top_title}
            card={{title: s.box_title, text: s.text}}
            imageRight={{src: s.image.url, alt: s.image.alt}}
          />
        </div>
      )}

      {false && <div className={"centeredSection " + styles.ourRestaurants} id="bigparner" style={{marginTop: '10rem'}}>
        <OurRestaurants
          title={bigpartner.title}
          card={bigpartner.card}
          booking={bigpartner.booking}
          imageRight={bigpartner.image_right}
          imageLeft={bigpartner.image_left}
        />
      </div>}
      
      {magazine && magazine.enabled && magazine.items && <div className={"magazine centeredSection " + styles.ourRestaurants} id="bigparner" style={{marginTop: '10rem', marginRight: '0', maxWidth: 'calc(1280px + (100% - 1280px) / 2)'}}>
        <MagazineContent data={magazine} />
      </div>}

      {carousel && carousel.map((d, i) => (
        <div
          style={{marginTop: '5rem'}}
          id={getId(d.title)}
          className={"anchor_section " + styles.cardCarousel}
          key={i}
        >
          <CardCarousel
            listOfBrands={d.items}
            loop={d.items.length > 4 ? true : false}
            centeredSlides={d.items.length > 4 ? true : false}
            darkTitle={d.title}
            hoverText={d.hoverText}
            autoplay={false}
          />
        </div>
      ))}


      {map && map.image && <div className={styles.mapContainer}>
        <div className={styles.title}>{map.title}</div>
        <div><img src={map.image} /></div>
      </div>}

      <div className="scroll">
        <ScrollDown selector={scrollToRef} scrollTop />
      </div>
    </TheMallOutletLayout>
  );
};

Restaurants.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  let properties = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);
  const resproperties = await fetchData(null, context.query.locale, 'GET', null, null, null, true);

  //console.log(context.query)
  if (resmenu) {
    menuItems = resmenu.menu;
  }
  //console.log('datacontent', data);
  let magazine = {
    enabled: false
  };
  let carousel = false;
  if (data) {
    if(data.magazine.enabled) {
      let _locale = context.query.locale;
      if( _locale != 'it')
        _locale = 'en';
      const magazineContent = await (await fetch(
        `https://backend.themall.it/${_locale}/wp-json/api/v1/get_ext_magazine/${data.magazine.tags}`
      )).json();
      magazine.enabled = data.magazine.enabled;
      magazine.items = magazineContent.data.items;
      magazine.title = data.magazine.content.title;
      magazine.html = data.magazine.content.text;
      magazine.cta = data.magazine.content.cta;

      carousel = data.carousel;
      //carousel.enabled = true;
    }
    console.log('carousel', data);
    dataContent = data;
  }

  if (resproperties) {
    properties = resproperties
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
    properties: properties,
    magazine: magazine,
    carousel: carousel
  };
};

export default Restaurants;
